import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const INITIAL_STATE = fromJS({
  roles: fromJS([]),
  fetching: false,
});

function getRoles(state, action) {
  return state.set('fetching', true);
}

function getRolesSuccess(state, action) {
  try {
    return state.set('fetching', false)
      .set('roles', fromJS(action.payload.body))
  } catch (e) {
    return state.set('fetching', false)
  }
}

function getRolesFail(state, action) {
  return state.set('fetching', false);
}

export const roles = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_ROLES]: getRoles,
  [ActionTypes.GET_ROLES_SUCCESS]: getRolesSuccess,
  [ActionTypes.GET_ROLES_FAIL]: getRolesFail
});



// WEBPACK FOOTER //
// ./src/reducers/roles.js